import { isApiError } from "@pandas/http-client";

export function getErrorMessage(e: unknown): string {
	if (isApiError(e)) return e.errorCode;
	if (e instanceof Error) return e.message;
	return "UNKNOWN_ERROR";
}
